import { timelineEvent } from "@/mocks/home";
import SectionHead from "./SectionHead";

const STATE_MARK: Record<string, { wrap: string; icon: string }> = {
  done: { wrap: "bg-primary-600 text-background-50", icon: "ri-check-line" },
  doing: { wrap: "bg-accent-500 text-foreground-950 animate-pulseDot", icon: "ri-loader-4-line" },
  todo: { wrap: "bg-background-200 text-foreground-500", icon: "ri-more-line" },
};

export default function Timeline() {
  return (
    <section id="track" className="scroll-mt-24 border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="TIMELINE"
          title="事件追踪"
          sub="一个瓜从头吃到尾，我们按时间顺序记录每次关键更新与待核实节点。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* intro card */}
          <div className="flex flex-col justify-between overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div>
              <div className="relative h-36 w-full overflow-hidden md:h-44">
                <img
                  src="https://readdy.ai/api/search-image?query=hand%20scrolling%20glowing%20phone%20screen%20at%20night%20against%20blurred%20city%20bokeh%20in%20crimson%20and%20amber%20tones%2C%20cinematic%20editorial%20social%20media%20photography%2C%20moody%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20investigative%20look&width=900&height=560&seq=track-stage&orientation=landscape"
                  alt="录音门事件追踪时间线背景图"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <span className="absolute bottom-3 left-4 inline-flex items-center gap-1.5 rounded-full bg-primary-600 px-3 py-1 text-xs font-bold text-background-50">
                  <span className="h-1.5 w-1.5 animate-pulseDot rounded-full bg-background-50" />
                  追踪中
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg font-black leading-snug text-foreground-950 md:text-xl">
                  {timelineEvent.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{timelineEvent.desc}</p>
              </div>
            </div>
            <div className="grid grid-cols-3 divide-x divide-background-200 border-t border-background-200">
              {[
                { k: "更新数", v: "24" },
                { k: "浏览", v: "112万" },
                { k: "待核实", v: "3" },
              ].map((s) => (
                <div key={s.k} className="px-3 py-3 text-center">
                  <div className="text-base font-black text-foreground-900 md:text-lg">{s.v}</div>
                  <div className="text-[11px] text-foreground-500">{s.k}</div>
                </div>
              ))}
            </div>
          </div>

          {/* timeline */}
          <div className="lg:col-span-2">
            <ol className="relative ml-3 border-l-2 border-background-300 pl-6 md:pl-8">
              {timelineEvent.stages.map((st) => {
                const mark = STATE_MARK[st.state];
                return (
                  <li key={st.label} className="relative pb-6 last:pb-0">
                    <span
                      className={`absolute -left-6 flex h-7 w-7 -translate-x-1/2 items-center justify-center rounded-full border-4 border-background-100 ${mark.wrap} md:-left-8`}
                    >
                      <i className={`text-[11px] ${mark.icon}`} />
                    </span>
                    <div className="flex flex-col gap-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-800">
                          {st.label}
                        </span>
                        <span className="text-xs text-foreground-400">{st.time}</span>
                      </div>
                      <h4 className="text-sm font-bold text-foreground-900 md:text-base">{st.title}</h4>
                      <p className="max-w-xl text-sm leading-relaxed text-foreground-600">{st.text}</p>
                    </div>
                  </li>
                );
              })}
            </ol>
            <a
              href="#stream"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-refresh-line" />
              跟随本事件
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}